import { ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { DateTimeExtensions_yyyy_MM_dd, stackClasses, doubleToTwoDecimals, DateTimeExtensions_toDate, logii, Locale_get_FromSelectedLanguage, DateTimeExtensions_to1stInMonth, logw, optToStr, Locale$reflection, DateOnlyExtensions_yyyy_MM_dd } from "../../Utils.js";
import { isNullOrWhiteSpace, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { record_type, lambda_type, class_type, option_type, string_type, list_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { CorrectionRequestDTO, SuspenseRow_FromDTO, MakeCorrectionDTO, renderUtcDate, SuspenseRow$reflection, MakeCorrectionDTO$reflection, MakeCorrectionResponse$reflection, CorrectionRequestDTO$reflection, CorrectionResponse$reflection, SuspenseRowDTO$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int32ToString, max, comparePrimitives, min, stringHash, compare, equals as equals_1, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { singleton as singleton_1, isEmpty, ofArray, cons, fold, tryHead, map as map_1, sortByDescending, skip, truncate, empty, length, filter as filter_1, contains, tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { toNumber, toString as toString_1 } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { SaveStatus, LoadState$2, GlobalDependencies$reflection, getTranslationFrom, SaveStatus$reflection, LoadState$2$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { UTCModule_toIso8601Z } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { fromNumber } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { addMonths, now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { fromDateTime } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { DateOptionsSimple, DateOptionsSimple_get_getDefault, inputDateSimple } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { dotsLoading, getMaterialIcon } from "../../ViewUtils.js";
import { info, error } from "../../Components/Message/Message.js";
import { CustomContentAreaTableProps, Elements_renderCell, renderCustomContentAreaTable, renderHeader } from "../../Components/Table/Table.js";
import "../../../src/Containers/Suspense/View.scss";


function Api_loadSuspense(clientNr, date) {
    let arg_1;
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, (arg_1 = DateOnlyExtensions_yyyy_MM_dd(date), toText(printf("/Data/R09/%i/%s"))(clientNr)(arg_1))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(SuspenseRowDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(SuspenseRowDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(SuspenseRowDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

function Api_loadCorrections(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/R09/%i/Correction/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(CorrectionResponse$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(CorrectionResponse$reflection(), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CorrectionRequestDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

function Api_saveCorrection(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/R09/%i/Correction/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(MakeCorrectionResponse$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(MakeCorrectionResponse$reflection(), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(MakeCorrectionDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(3), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(MakeCorrectionResponse$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

function tryFindCorrection(suspenseRow, correctionResponseLoadState) {
    if (correctionResponseLoadState.tag === 2) {
        return tryFind((r) => {
            if (equals_1(r.NumberFrom, suspenseRow.A_Number)) {
                return true;
            }
            else {
                return equals_1(map(toString_1, r.Imsi), suspenseRow.Imsi);
            }
        }, correctionResponseLoadState.fields[0].Result);
    }
    else {
        return void 0;
    }
}

class ContentAreaProps extends Record {
    constructor(Locale, SuspenseRow, CorrectionResponseLoadState, OnClickFixCorrectionFn, CorrectedRows) {
        super();
        this.Locale = Locale;
        this.SuspenseRow = SuspenseRow;
        this.CorrectionResponseLoadState = CorrectionResponseLoadState;
        this.OnClickFixCorrectionFn = OnClickFixCorrectionFn;
        this.CorrectedRows = CorrectedRows;
    }
}

function ContentAreaProps$reflection() {
    return record_type("Containers.Suspense.View.ContentAreaProps", [], ContentAreaProps, () => [["Locale", Locale$reflection()], ["SuspenseRow", SuspenseRow$reflection()], ["CorrectionResponseLoadState", LoadState$2$reflection(CorrectionResponse$reflection(), string_type)], ["OnClickFixCorrectionFn", lambda_type(string_type, lambda_type(MakeCorrectionDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [SaveStatus$reflection()])))], ["CorrectedRows", list_type(string_type)]]);
}

const renderContentArea = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_2, children_6, children_4, arg, children_9, arg_18;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalOpenState = react.useState(false);
    const missingCorrectionHtml = getTranslation("Suspense.MissingInformation");
    let contentHtml;
    const matchValue = tryFindCorrection(props.SuspenseRow, props.CorrectionResponseLoadState);
    if (matchValue != null) {
        const correction = matchValue;
        const matchValue_1 = correction.ActiveTo;
        if (matchValue_1 != null) {
            const correctionActiveTo = matchValue_1;
            const contractedEndDate = correctionActiveTo;
            const contractedStartDate = correction.ActiveFrom;
            const activityStartDate = props.SuspenseRow.MinStartTime;
            const activityEndDate = props.SuspenseRow.MaxStartTime;
            const patternInput = (compare(activityStartDate, contractedStartDate) < 0) ? [activityStartDate, contractedEndDate, true, true] : ((compare(activityEndDate, contractedEndDate) > 0) ? [contractedStartDate, activityEndDate, false, true] : [contractedStartDate, contractedEndDate, false, false]);
            const activityInPast = patternInput[2];
            const activeToCorrection = patternInput[1];
            const activeFromCorrection = patternInput[0];
            const hasJustBeenCorrected = contains(props.SuspenseRow.SearchFriendlyString, props.CorrectedRows, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
            if (!patternInput[3]) {
                const children_8 = [(children = [getTranslation("Suspense.NoCorrection1")], react.createElement("div", {}, ...children)), (children_2 = [getTranslation("Suspense.NoCorrection2")], react.createElement("div", {}, ...children_2)), (children_6 = [(children_4 = [(arg = getTranslation("Suspense.NoCorrection3"), toText(printf("(%s.)"))(arg))], react.createElement("small", {}, ...children_4))], react.createElement("div", {}, ...children_6))];
                contentHtml = react.createElement(react.Fragment, {}, ...children_8);
            }
            else if (hasJustBeenCorrected) {
                const children_11 = [(children_9 = [getTranslation("Suspense.ActionTaken")], react.createElement("div", {}, ...children_9))];
                contentHtml = react.createElement(react.Fragment, {}, ...children_11);
            }
            else {
                const renderColoredDates = (dateLeft, colorClassLeft, dateRight, colorClassRight) => {
                    let props_13, children_12, props_15, children_14;
                    const children_16 = [(props_13 = [new HTMLAttr(65, colorClassLeft), new HTMLAttr(158, renderUtcDate(props.Locale, dateLeft))], (children_12 = [renderUtcDate(props.Locale, dateLeft)], react.createElement("span", keyValueList(props_13, 1), ...children_12))), " - ", (props_15 = [new HTMLAttr(65, colorClassRight), new HTMLAttr(158, renderUtcDate(props.Locale, dateRight))], (children_14 = [renderUtcDate(props.Locale, dateRight)], react.createElement("span", keyValueList(props_15, 1), ...children_14)))];
                    return react.createElement(react.Fragment, {}, ...children_16);
                };
                let contractedActivePeriodHtml;
                let imsiContractedStr;
                const arg_3 = getTranslation("Suspense.ImsiContracted2");
                const arg_2 = optToStr(correction.Imsi);
                const arg_1 = getTranslation("Suspense.ImsiContracted1");
                imsiContractedStr = toText(printf("%s (%s) %s: "))(arg_1)(arg_2)(arg_3);
                const activePeriodsHtml = renderColoredDates(contractedStartDate, "yellow", contractedEndDate, "gray");
                contractedActivePeriodHtml = react.createElement("div", {}, imsiContractedStr, activePeriodsHtml);
                let trafficHappenedHtml;
                const beforeAfterStr = activityInPast ? getTranslation("Common.Before").toLocaleLowerCase() : getTranslation("Common.After").toLocaleLowerCase();
                let trafficStr;
                const arg_6 = getTranslation("Suspense.TrafficHappened2");
                const arg_4 = getTranslation("Suspense.TrafficHappened1");
                trafficStr = toText(printf("%s %s %s: "))(arg_4)(beforeAfterStr)(arg_6);
                const trafficPeriodsHtml = renderColoredDates(activityStartDate, "blue", activityEndDate, "green");
                trafficHappenedHtml = react.createElement("div", {}, trafficStr, trafficPeriodsHtml);
                let changeToHtml_1;
                let changeToQuestionStr;
                const arg_9 = getTranslation("Common.To").toLocaleLowerCase();
                const arg_8 = (~(~toNumber(correction.ContractNr))) | 0;
                const arg_7 = getTranslation("Suspense.ChangeActivePeriod");
                changeToQuestionStr = toText(printf("%s %i %s "))(arg_7)(arg_8)(arg_9);
                let changeToHtml;
                const patternInput_1 = activityInPast ? ["blue", "gray"] : ["yellow", "green"];
                changeToHtml = renderColoredDates(activeFromCorrection, patternInput_1[0], activeToCorrection, patternInput_1[1]);
                changeToHtml_1 = react.createElement("div", {}, changeToQuestionStr, changeToHtml, "?");
                let consequenceHtml;
                let consequenceStr;
                const arg_11 = (~(~toNumber(correction.ContractNr))) | 0;
                const arg_10 = getTranslation("Suspense.Consequences");
                consequenceStr = toText(printf("%s %i."))(arg_10)(arg_11);
                consequenceHtml = react.createElement("div", {}, consequenceStr);
                let fixButtonAndModalHtml;
                let modalHtml;
                const matchValue_2 = modalOpenState[0];
                if (matchValue_2) {
                    let bodyHtml;
                    let text1;
                    const arg_14 = getTranslation("Common.To").toLocaleLowerCase();
                    const arg_13 = (~(~toNumber(correction.ContractNr))) | 0;
                    const arg_12 = getTranslation("Suspense.ActivePeriodWillChange");
                    text1 = toText(printf("%s %i %s:"))(arg_12)(arg_13)(arg_14);
                    let text2;
                    const arg_16 = renderUtcDate(props.Locale, activeToCorrection);
                    const arg_15 = renderUtcDate(props.Locale, activeFromCorrection);
                    text2 = toText(printf("%s - %s."))(arg_15)(arg_16);
                    const children_26 = [text1, react.createElement("br", {}), text2];
                    bodyHtml = react.createElement("p", {
                        className: "p-2",
                    }, ...children_26);
                    modalHtml = renderModal(getTranslation("Common.Confirm"), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Confirm"), (_arg_1) => {
                        modalOpenState[1](false);
                    }, (_arg_2) => {
                        let a;
                        startImmediate((a = props.OnClickFixCorrectionFn(props.SuspenseRow.SearchFriendlyString, new MakeCorrectionDTO(correction.CountryCode, ~(~toNumber(correction.ContractNr)), UTCModule_toIso8601Z(correction.ActiveFrom), UTCModule_toIso8601Z(correctionActiveTo), map((value_1) => fromNumber(toNumber(value_1), false), correction.Imsi), UTCModule_toIso8601Z(activeFromCorrection), UTCModule_toIso8601Z(activeToCorrection))), singleton.Delay(() => singleton.Bind(a, (_arg_3) => singleton.Return(void _arg_3)))));
                        modalOpenState[1](false);
                    });
                }
                else {
                    modalHtml = react.createElement(react.Fragment, {});
                }
                const children_28 = [wrappedButton(new ButtonKind(0), new ButtonProps((arg_18 = getTranslation("Suspense.Fix"), toText(printf("%s..."))(arg_18)), defaultProps.Content, (_arg_4) => {
                    modalOpenState[1](true);
                }, defaultProps.Disabled, "suspense-fix-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalHtml];
                fixButtonAndModalHtml = react.createElement("div", {
                    className: "mt-3",
                }, ...children_28);
                contentHtml = react.createElement(react.Fragment, {}, contractedActivePeriodHtml, trafficHappenedHtml, changeToHtml_1, consequenceHtml, fixButtonAndModalHtml);
            }
        }
        else {
            contentHtml = missingCorrectionHtml;
        }
    }
    else {
        contentHtml = missingCorrectionHtml;
    }
    return react.createElement("div", {
        className: "suspense-table__content-area",
    }, contentHtml);
}, "SuspenseContentArea", uncurry(2, void 0), void 0, "renderContentArea", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Suspense\\View.fs", 245);

function getSearchFilteredRows(filter, suspenseRows) {
    if (!isNullOrWhiteSpace(filter)) {
        return filter_1((c) => (c.SearchFriendlyString.indexOf(filter.toLocaleLowerCase()) >= 0), suspenseRows);
    }
    else {
        return suspenseRows;
    }
}

function getCurrentRows(pageSize, currentPage, filteredRows) {
    const nrOfRows = length(filteredRows) | 0;
    const currentSkip = (pageSize * currentPage) | 0;
    if ((currentSkip < 0) ? true : (currentSkip > nrOfRows)) {
        logw(toText(printf("[Pagination] currentSkip: %i, nrOfRows: %i"))(currentSkip)(nrOfRows));
    }
    const currentTake = min(comparePrimitives, pageSize, max(comparePrimitives, 0, nrOfRows - currentSkip)) | 0;
    if (length(filteredRows) < currentSkip) {
        return empty();
    }
    else {
        return truncate(currentTake, skip(currentSkip, filteredRows));
    }
}

export class SuspenseProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function SuspenseProps$reflection() {
    return record_type("Containers.Suspense.View.SuspenseProps", [], SuspenseProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const renderSuspense = FunctionComponent_Of_Z5A158BBF((props) => {
    let copyOfStruct, children, arg_7, inputRecord, props_6, children_5, children_22, arg_9, arg_8, matchValue_8, arg_12, children_47, children_41, children_45, props_46, children_43;
    const suspenseRowsPageSize = 10;
    const initialDateTime = DateTimeExtensions_to1stInMonth((copyOfStruct = now(), addMonths(copyOfStruct, -1)));
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const afterDateState = react.useState(initialDateTime);
    const searchFilterState = react.useState("");
    const correctedRowsState = react.useState(empty());
    const pageState = react.useState(0);
    const suspenseRowsLoadState = react.useState(new LoadState$2(0));
    const correctionResponseLoadState = react.useState(new LoadState$2(0));
    const loadSuspense = (afterDate) => {
        suspenseRowsLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(Api_loadSuspense(props.GlobalDependencies.ClientNr, fromDateTime(afterDate)), (_arg_1) => {
            const result_1 = _arg_1;
            const arg_5 = (result_1.tag === 0) ? (new LoadState$2(2, sortByDescending((s) => s.OrigCostExclVat, map_1((arg_3) => SuspenseRow_FromDTO(locale, arg_3), result_1.fields[0]), {
                Compare: compare,
            }))) : (new LoadState$2(3, result_1.fields[0]));
            suspenseRowsLoadState[1](arg_5);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        let a, patternInput;
        const matchValue_2 = suspenseRowsLoadState[0];
        if (matchValue_2.tag === 2) {
            let rows;
            const filteredRows = getSearchFilteredRows(searchFilterState[0], matchValue_2.fields[0]);
            rows = getCurrentRows(suspenseRowsPageSize, pageState[0], filteredRows);
            const matchValue = tryHead(rows);
            if (matchValue != null) {
                const row = matchValue;
                startImmediate((a = Api_loadCorrections(props.GlobalDependencies.ClientNr, (patternInput = fold((acc, curr) => {
                    const matchValue_1 = [curr.A_Number, curr.Imsi];
                    if (matchValue_1[0] != null) {
                        return [cons(matchValue_1[0], acc[0]), acc[1]];
                    }
                    else if (matchValue_1[1] != null) {
                        return [acc[0], cons(matchValue_1[1], acc[1])];
                    }
                    else {
                        return acc;
                    }
                }, [empty(), empty()], rows), new CorrectionRequestDTO(row.NetworkContractNr, patternInput[0], patternInput[1]))), singleton.Delay(() => singleton.Bind(a, (_arg) => {
                    let result, arg;
                    return singleton.Return((result = _arg, (arg = ((result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]))), correctionResponseLoadState[1](arg))));
                }))));
            }
            else {
                logii("Cannot loadCorrections, no available rows to check.");
            }
        }
    }, [pageState[0], searchFilterState[0], suspenseRowsLoadState[0]]);
    react.useEffect(() => {
        loadSuspense(initialDateTime);
    }, [props.GlobalDependencies]);
    let afterDateHtml;
    const children_2 = [(children = [(arg_7 = getTranslation("Common.After"), toText(printf("%s:"))(arg_7))], react.createElement("span", {}, ...children)), inputDateSimple((inputRecord = DateOptionsSimple_get_getDefault(), new DateOptionsSimple("suspense-after-date-pickr", afterDateState[0], (dt) => {
        afterDateState[1](dt);
        loadSuspense(dt);
    }, (date_1) => DateTimeExtensions_toDate(locale.ILocale, date_1), inputRecord.TimeTwentyFour, inputRecord.LabelText, true, inputRecord.Disabled, locale, inputRecord.EnableBy, inputRecord.OnClearClick, inputRecord.ExtraFlatpickrOptions)))];
    afterDateHtml = react.createElement("div", {
        className: "suspense__after-date-container",
    }, ...children_2);
    let subscriptionSearchHtml;
    const matchValue_3 = suspenseRowsLoadState[0];
    if (matchValue_3.tag === 2) {
        if (length(matchValue_3.fields[0]) <= suspenseRowsPageSize) {
            subscriptionSearchHtml = react.createElement(react.Fragment, {});
        }
        else {
            const children_7 = [(props_6 = [new HTMLAttr(65, "search__input"), new HTMLAttr(128, getTranslation("Suspense.Search")), ["data-translation", "Suspense.Search"], new HTMLAttr(99, "suspense-search-input"), new DOMAttr(9, (event) => {
                searchFilterState[1](Browser_Types_Event__Event_get_Value(event));
            })], react.createElement("input", keyValueList(props_6, 1))), (children_5 = [getMaterialIcon("search")], react.createElement("div", {
                className: "search__icon",
            }, ...children_5))];
            subscriptionSearchHtml = react.createElement("div", {
                className: "suspense__search",
            }, ...children_7);
        }
    }
    else {
        subscriptionSearchHtml = react.createElement(react.Fragment, {});
    }
    let suspenseTableHtml;
    const matchValue_5 = suspenseRowsLoadState[0];
    switch (matchValue_5.tag) {
        case 1: {
            suspenseTableHtml = dotsLoading;
            break;
        }
        case 3: {
            suspenseTableHtml = error(matchValue_5.fields[0].split(""));
            break;
        }
        case 2: {
            const suspenseRows_3 = matchValue_5.fields[0];
            const headers = map_1(renderHeader, ofArray([getTranslation("Suspense.TableHeading.Port"), getTranslation("Suspense.TableHeading.Phonenumber"), "IMSI", getTranslation("Suspense.TableHeading.From"), getTranslation("Suspense.TableHeading.To"), getTranslation("Suspense.TableHeading.NoPosts"), getTranslation("Suspense.TableHeading.TotalAmount")]));
            const filteredRows_1 = getSearchFilteredRows(searchFilterState[0], suspenseRows_3);
            let tableHtml;
            const nrOfRows = length(filteredRows_1) | 0;
            const currentSkip = (suspenseRowsPageSize * (pageState[0])) | 0;
            const currentTake = min(comparePrimitives, suspenseRowsPageSize, max(comparePrimitives, 0, nrOfRows - currentSkip)) | 0;
            const currentRows = getCurrentRows(suspenseRowsPageSize, pageState[0], filteredRows_1);
            let genericPaginationContainerHtml;
            const matchValue_7 = nrOfRows > suspenseRowsPageSize;
            if (matchValue_7) {
                let paginationInfoHtml;
                const children_24 = [(children_22 = [(arg_9 = ((currentSkip + currentTake) | 0), (arg_8 = ((currentSkip + 1) | 0), toText(printf("%i-%i / %i"))(arg_8)(arg_9)(nrOfRows)))], react.createElement("span", {}, ...children_22))];
                paginationInfoHtml = react.createElement("div", {}, ...children_24);
                let buttonsHtml;
                let backButton;
                const isDisabled = (pageState[0]) === 0;
                const children_17 = [getMaterialIcon("chevron_left")];
                backButton = react.createElement("button", {
                    disabled: isDisabled,
                    type: "button",
                    className: "btn btn-outline-secondary generic-pagination-button",
                    onClick: (_arg_6) => {
                        pageState[1]((x_6) => (x_6 - 1));
                    },
                }, ...children_17);
                let forwardButton;
                const isDisabled_1 = nrOfRows <= (currentSkip + currentTake);
                const children_19 = [getMaterialIcon("chevron_right")];
                forwardButton = react.createElement("button", {
                    disabled: isDisabled_1,
                    type: "button",
                    className: "btn btn-outline-secondary generic-pagination-button",
                    onClick: (_arg_7) => {
                        pageState[1]((x_7) => (x_7 + 1));
                    },
                }, ...children_19);
                buttonsHtml = react.createElement("div", {
                    className: "generic-pagination__buttons-container",
                }, backButton, forwardButton);
                genericPaginationContainerHtml = react.createElement("div", {
                    className: "generic-pagination__container",
                }, paginationInfoHtml, buttonsHtml);
            }
            else {
                genericPaginationContainerHtml = react.createElement(react.Fragment, {});
            }
            const renderedHtml = renderCustomContentAreaTable(new CustomContentAreaTableProps(headers, map_1((row_1) => {
                let iconHtml, matchValue_6, correction, portHtml, children_13;
                const correctionOpt = tryFindCorrection(row_1, correctionResponseLoadState[0]);
                const renderCell = (content) => Elements_renderCell(react.createElement("span", {
                    className: "pointer",
                }, content));
                return [ofArray([Elements_renderCell((iconHtml = ((matchValue_6 = [contains(row_1.SearchFriendlyString, correctedRowsState[0], {
                    Equals: (x_3, y_1) => (x_3 === y_1),
                    GetHashCode: stringHash,
                }), correctionOpt], matchValue_6[0] ? getMaterialIcon("done") : ((matchValue_6[1] != null) ? ((correction = matchValue_6[1], getMaterialIcon("edit"))) : getMaterialIcon("help_outline")))), (portHtml = ((children_13 = [int32ToString(row_1.PortNr)], react.createElement("span", {
                    className: "port__small",
                }, ...children_13))), react.createElement("div", {
                    className: "suspense-table__port",
                }, iconHtml, portHtml, row_1.Name)))), renderCell(optToStr(row_1.A_Number)), renderCell(optToStr(row_1.Imsi)), renderCell(renderUtcDate(locale, row_1.MinStartTime)), renderCell(renderUtcDate(locale, row_1.MaxStartTime)), renderCell(int32ToString(row_1.N)), renderCell(optToStr(map(doubleToTwoDecimals, row_1.OrigCostExclVat)))]), row_1.SearchFriendlyString];
            }, currentRows), (rowId) => map((row_2) => renderContentArea(new ContentAreaProps(locale, row_2, correctionResponseLoadState[0], (correctionId, dto_1) => singleton.Delay(() => singleton.Bind(Api_saveCorrection(props.GlobalDependencies.ClientNr, dto_1), (_arg_2) => {
                const result_2 = _arg_2;
                let loadResult;
                if (result_2.tag === 0) {
                    correctedRowsState[1]((correctedRows) => cons(correctionId, correctedRows));
                    loadResult = (new SaveStatus(2));
                }
                else {
                    loadResult = (new SaveStatus(3, result_2.fields[0]));
                }
                return singleton.Return(loadResult);
            })), correctedRowsState[0])), tryFind((r_1) => (r_1.SearchFriendlyString === rowId), suspenseRows_3)), void 0));
            tableHtml = ((nrOfRows === 0) ? renderedHtml : react.createElement("div", {
                className: "generic-pagination",
            }, renderedHtml, genericPaginationContainerHtml));
            let noRowsMsgHtml;
            if (isEmpty(filteredRows_1)) {
                const props_35 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-center", "mt-3"])))];
                const children_32 = [info(getTranslation("Suspense.CouldNotFindData").split(""))];
                noRowsMsgHtml = react.createElement("div", keyValueList(props_35, 1), ...children_32);
            }
            else {
                noRowsMsgHtml = react.createElement(react.Fragment, {});
            }
            suspenseTableHtml = react.createElement("div", {
                className: "suspense-table",
            }, tableHtml, noRowsMsgHtml);
            break;
        }
        default: {
            suspenseTableHtml = react.createElement(react.Fragment, {});
        }
    }
    const correctionResponseErrorHtml = defaultArg(map((msg_5) => error(msg_5.split("")), (matchValue_8 = (correctionResponseLoadState[0]), (matchValue_8.tag === 3) ? matchValue_8.fields[0] : ((matchValue_8.tag === 2) ? matchValue_8.fields[0].Error : (void 0)))), react.createElement(react.Fragment, {}));
    let downloadToExcelBtnHtml;
    const matchValue_9 = suspenseRowsLoadState[0];
    let pattern_matching_result;
    if (matchValue_9.tag === 1) {
        pattern_matching_result = 0;
    }
    else if (matchValue_9.tag === 3) {
        pattern_matching_result = 0;
    }
    else if (matchValue_9.tag === 2) {
        if (isEmpty(matchValue_9.fields[0])) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            downloadToExcelBtnHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 1: {
            const matchValue_10 = ValidatedUrlModule_create(new UrlKind(0, (arg_12 = DateTimeExtensions_yyyy_MM_dd(afterDateState[0]), toText(printf("/Data/R09/slk/%i/%s/%s"))(props.GlobalDependencies.ClientNr)(arg_12)(props.GlobalDependencies.SelectedLanguage))));
            if (matchValue_10.tag === 0) {
                const props_42 = [new HTMLAttr(65, "fit-content"), new HTMLAttr(94, ValidatedUrl__get_Value(matchValue_10.fields[0]))];
                const children_39 = [wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Suspense.DownloadToExcel"), defaultProps.Content, (value_4) => {
                }, defaultProps.Disabled, "suspense-download-excel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
                downloadToExcelBtnHtml = react.createElement("a", keyValueList(props_42, 1), ...children_39);
            }
            else {
                downloadToExcelBtnHtml = error(matchValue_10.fields[0].split(""));
            }
            break;
        }
    }
    const children_51 = [(children_47 = [(children_41 = [getTranslation("Suspense.Heading")], react.createElement("h1", {}, ...children_41)), (children_45 = [(props_46 = [new HTMLAttr(65, stackClasses(singleton_1("blockquote-footer")))], (children_43 = [getTranslation("Suspense.Heading2")], react.createElement("footer", keyValueList(props_46, 1), ...children_43)))], react.createElement("h5", {}, ...children_45))], react.createElement("div", {}, ...children_47)), react.createElement("div", {
        className: "suspense__vertical-container",
    }, afterDateHtml, subscriptionSearchHtml), suspenseTableHtml, downloadToExcelBtnHtml, correctionResponseErrorHtml];
    return react.createElement("div", {
        className: "suspense",
    }, ...children_51);
}, "Suspense", uncurry(2, void 0), void 0, "renderSuspense", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Suspense\\View.fs", 595);

